import React, { useEffect, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import { useLocation, useNavigate } from "react-router";
import { Button, Typography } from "@mui/material";
import axios from "axios";
import { commonUrl, redirectUrl } from "src/config";
import dayjs from "dayjs";

const DeliveryReportPrint = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const componentRef = useRef();

  const { header = {}, table = [], type = "DELIVERY REPORT" } = state || {};

  const { fromDate, toDate, party } = header;
  console.log({ fromDate, toDate, party });
  
  const [company, setCompany] = useState(null);
  const [logo, setLogo] = useState(null);
  // const isInvalidDate = (dateStr) => isNaN(Date.parse(dateStr));

  // const getCurrentFormattedDate = () => {
  //   const now = new Date();
  //   return now.toLocaleDateString("en-GB"); // 'DD/MM/YYYY' format
  // };

  // if (isInvalidDate(fromDate) || isInvalidDate(toDate)) {
  //   const today = getCurrentFormattedDate();
  //   header.fromDate = today;
  //   header.toDate = today;
  // }
  useEffect(() => {
    function getStatusDatas() {
      axios
        .get(commonUrl + "main/getCompanyDetails", { withCredentials: true })
        .then((res) => {
          if (res.data[0]) {
            setCompany(res?.data[0]);
            if (res?.data[0]?.logo) {
              const parseLogo = JSON.parse(res?.data[0]?.logo);
              setLogo(parseLogo?.img);
            }
          }
        })
        .catch((err) => {
          if (err.response?.status === 401 || err.response?.status === 403) {
            window.location.href = redirectUrl;
          }
          alert(err);
        });
    }

    getStatusDatas();
  }, []);
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `SalesReport from ${fromDate} to ${toDate}`,
    onAfterPrint: () => {
      navigate(-1); // navigates back to the previous page
    },
  });
  const totalAmount = table.reduce(
    (sum, row) => sum + Number(row.Total || 0),
    0
  );
  const totalReceived = table.reduce(
    (sum, row) => sum + Number(row.Received || 0),
    0
  );
  const totalCredit = totalAmount - totalReceived;

  return (
    <div style={{ padding: "12px" }}>
      <div style={{ marginBottom: "10px" }}>
        <Button variant="contained" onClick={handlePrint}>
          Print
        </Button>
        <Button style={{ marginLeft: "10px" }} onClick={() => navigate(-1)}>
          Back
        </Button>
      </div>

      <div
        ref={componentRef}
        style={{
          backgroundColor: "#fff",
          padding: "25px",
          fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        }}
      >
        <div style={{ textAlign: "center" }}>
          {/* {logo && <img src={logo} width={90} alt="logo" />} */}
          <h3>{company?.Name}</h3>
          <p>
            {company?.Add1} {company?.Place}
          </p>
          <p>{company?.Ph}</p>
          <p>{company?.Web}</p>
        </div>
        {/* Header Section */}
        <div
          style={{
            color: "#000",
            padding: "16px",
            borderRadius: "6px",
            marginBottom: "20px",
            textAlign: "center",
          }}
        >
          <Typography variant="h5" style={{ fontWeight: "bold" }}>
            DELIVERY REPORT
          </Typography>
          <div style={{ display: "flex", justifyContent: "center", gap: 10 }}>
            <Typography variant="subtitle1">From: {fromDate}</Typography>
            <Typography variant="subtitle1">To: {toDate}</Typography>
          </div>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Typography variant="subtitle1">
            Branch: {header.branch?.label || "ALL"}
          </Typography>
          <Typography variant="subtitle1">
            Party: {party?.label || "ALL"}
          </Typography>
        </div>
        {/* Table Section */}

        <table
          style={{
            width: "100%",
            textAlign: "center",
            fontSize: "13px",
            borderCollapse: "collapse",
            marginBottom: "20px",
          }}
        >
          <thead style={{ backgroundColor: "#f0f0f0" }}>
            <tr>
              {[
                "SI",
                "Bill No",
                "Party",
                "Item",
                "ItemType",
                "Variant",
                "Qty",
                "Delivery Date"
              ].map((header, i) => (
                <th
                  key={i}
                  style={{
                    border: "1px solid #ccc",
                    padding: "8px",
                    fontWeight: "bold",
                  }}
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {table.map((row, idx) => (
              <tr
                key={idx}
                style={{ backgroundColor: idx % 2 === 0 ? "#fafafa" : "#fff" }}
              >
                <td style={{ border: "1px solid #ccc", padding: "6px" }}>
                  {idx + 1}
                </td>
                <td style={{ border: "1px solid #ccc", padding: "6px" }}>
                  {row.BillNo}
                </td>
                <td style={{ border: "1px solid #ccc", padding: "6px" }}>
                  {row.Party}
                </td>
                <td style={{ border: "1px solid #ccc", padding: "6px" }}>
                  {row.Item}
                </td>
                <td style={{ border: "1px solid #ccc", padding: "6px" }}>
                  {row.unit}
                </td>
                <td style={{ border: "1px solid #ccc", padding: "6px" }}>
                  {row.note}
                </td>
                 <td style={{ border: "1px solid #ccc", padding: "6px" }}>
                  {row.Qty}
                </td>
                <td style={{ border: "1px solid #ccc", padding: "6px" }}>
                  {dayjs(row.exp_date).format("DD/MM/YYYY")}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Totals */}
        {/* <div style={{ textAlign: "right", marginBottom: "20px" }}>
          <Typography variant="body1">
            <strong>Total Amount:</strong> ₹{totalAmount.toFixed(2)}
          </Typography>
          <Typography variant="body1">
            <strong>Total Received:</strong> ₹{totalReceived.toFixed(2)}
          </Typography>
          <Typography variant="body1">
            <strong>Total Credit:</strong> ₹{totalCredit.toFixed(2)}
          </Typography>
        </div> */}

        <hr />
      </div>
    </div>
  );
};

export default DeliveryReportPrint;
